import { communityRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const communityRoute: RouteObject[] = [
  {
    path: communityRoutePaths.realEstateList.path,
    async lazy() {
      const Page = await import('@/pages/community/real-estate-community-list-page');
      return { Component: Page.default };
    },
  },
  {
    path: communityRoutePaths.realEstateWrite.path,
    async lazy() {
      const Page = await import('@/pages/community/real-estate-community-write-page');
      return { Component: Page.default };
    },
  },
  {
    path: communityRoutePaths.realEstateDetail.path,
    async lazy() {
      const Page = await import('@/pages/community/real-estate-community-detail-page');
      return { Component: Page.default };
    },
  },
];
